// extracted by mini-css-extract-plugin
module.exports = {"container":"BodySectionContainer_container__3n0x_"};